import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"whatsapp",attrs:{"href":"https://api.whatsapp.com/send?phone=51908825711&text=Hola, tengo una duda!","target":"_blank"}},[_c(VIcon,{staticClass:"white--text whatsapp-icon",staticStyle:{"font-size":"40px"},attrs:{"color":"#FFFFFF"}},[_vm._v(" mdi-whatsapp")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }